<form [formGroup]="form" class="report-filters">
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="startDate" [placeholder]="'Start Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="endDate" [placeholder]="'End Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-dropdown formControlName="status" [showClear]="true" [options]="policyStatuses"
                placeholder="Policy status"></p-dropdown>
        </span>
    </div>
    <div class="controls-wrapper" *ngIf="canFilterByUser">
        <span class="p-input-icon-right">
            <p-dropdown formControlName="user" [showClear]="true" [options]="users"
                placeholder="Choose user"></p-dropdown>
        </span>
    </div>

    <div class="controls-wrapper button-wrapper">
        <p-button label="Search" [text]="true" [raised]="true" [disabled]="form.invalid" (onClick)="submit()"
            severity="success" class="report-action-button" icon="pi pi-search"></p-button>
        <p-button label="Export" [text]="true" [raised]="true" severity="success" (onClick)="export()"
            class="report-action-button" icon="pi pi-download"></p-button>
    </div>
</form>
<hr />
<div class="table-container">
    <p-table [value]="reports" [scrollable]="true" #reportTable scrollHeight="400px"
        styleClass="p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }" id="smeReportsTable"
        responsiveLayout="stack" [breakpoint]="'768px'">
        <ng-template pTemplate="header">
            <tr>
                <th>Date</th>
                <th>Product</th>
                <th>Insured Name</th>
                <th>Origin</th>
                <th>Departure Date</th>
                <th>Departure Time</th>
                <th>Destination</th>
                <th>Arrival Date</th>
                <th>Arrival Time</th>
                <th>Inception Date</th>
                <th>End Date</th>
                <th>Sum Insured</th>
                <th>Policy Number</th>
                <th>Total Payable Amount</th>
                <th>Payment Provider</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
            <tr>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Date</span>
                    {{ report.dateCreated | date : "dd/MM/yyyy" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Product</span>
                    {{ report.product ? report.product : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Insured Name</span>
                    {{ report.insuredName.split(".").join(" ") }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Origin</span>
                    {{ report.origin }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Departure Date</span>
                    {{ report.departureDate | date : "dd/MM/yyyy" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Departure Time</span>
                    {{ report.departureTime }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Destination</span>
                    {{ report.destination }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Arrival Date</span>
                    {{ report.arrivalDate | date : "dd/MM/yyyy" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Arrival Time</span>
                    {{ report.arrivalTime }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Inception Date</span>
                    {{ report.inceptionDate | date : "dd/mm/yyyy" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">End Date</span>
                    {{ report.endDate | date : "dd/mm/yyyy" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Sum Insured</span>
                    {{ report.sumInsured ? (report.sumInsured | currency) : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Policy Number</span>
                    {{ report.policyNumber ? report.policyNumber : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Total Payable Amount</span>
                    {{ report.totalPayableAmount ? (report.totalPayableAmount | currency) : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Payment Provider</span>
                    {{ report.paymentProvider ? report.paymentProvider : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Status</span>
                    {{ report.status ? report.status : "---" }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
